export default __webpack_public_path__ + "static/media/QR-Code.16a9d0a0.png";